/**
 * Pull to refresh only when this element is the scroller.
 * Listeners stay passive. Nothing calls preventDefault, and touchmove
 * is not observed, so a flick can keep its momentum.
 */

function installPullRefresh(scroller, onRefresh) {
  if (!scroller || typeof scroller.addEventListener !== 'function') return function noop() {};
  let startY = 0;
  let armed = false;
  const scrollsItself = () => scroller.scrollHeight > scroller.clientHeight + 8;
  const onStart = (event) => {
    if (!scrollsItself() || scroller.scrollTop > 8) return;
    startY = event.touches && event.touches[0] ? event.touches[0].clientY : 0;
    armed = true;
  };
  const onEnd = (event) => {
    if (!armed) return;
    armed = false;
    const endY = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : startY;
    if (scroller.scrollTop > 8 || endY - startY < 72) return;
    if (typeof onRefresh === 'function') onRefresh();
  };
  const passive = { passive: true };
  scroller.addEventListener('touchstart', onStart, passive);
  scroller.addEventListener('touchend', onEnd, passive);
  return function removePullRefresh() {
    scroller.removeEventListener('touchstart', onStart);
    scroller.removeEventListener('touchend', onEnd);
  };
}

module.exports = {
  installPullRefresh,
};
